import {useEffect, useState} from "react"

export interface SegmentInfo {
    name: string
    description: string
    distance: number
}

interface SegmentInfoPanelProps {
    segmentInfo: SegmentInfo | null
}

export const SegmentInfoPanel: React.FC<SegmentInfoPanelProps> = ({segmentInfo}) => {
    const [isExpanded, setIsExpanded] = useState(false)

    if (!segmentInfo) return null

    return (
        <div className="fixed top-4 right-4 z-50" onClick={() => setIsExpanded(!isExpanded)}>
            <div
                className={`
              bg-white shadow-lg rounded-lg transition-all duration-200 ease-in-out cursor-pointer
              ${isExpanded ? "w-80 p-4" : "w-auto p-2"}
          `}
            >
                <div className="flex items-center justify-between">
                    <span className="font-medium text-gray-800">{segmentInfo.name}</span>
                    <span className="text-sm text-gray-500 ml-2">{segmentInfo.distance.toFixed(2)}</span>
                </div>

                {isExpanded && (
                    <div className="mt-3">
                        <div className="text-sm text-gray-600">{segmentInfo.description}</div>
                    </div>
                )}
            </div>
        </div>
    )
}
